/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { JSXElementConstructor } from 'react';
import { Button } from 'reactstrap';
import './styles.scss';

interface BasicAlertParams {
  message?: string | JSXElementConstructor<any>;
  hide?: boolean,
  children: any,
  className?: string,
  handleClose?: () => void,
  variant?: VariantType,
}

export enum VariantType {
  Absolute = 'absolute',
  Sticky = 'sticky',
  Auto = 'auto',
}

const VARIANT_MAP: Record<VariantType, React.CSSProperties> = {
  [VariantType.Absolute]: {
    position: 'absolute',
    top: 0,
  },
  [VariantType.Sticky]: {
    position: 'sticky',
    top: '53px', // offset by header height
    zIndex: 2, // reset z-index so banner only stacks above body content & select dropdowns
  },
  [VariantType.Auto]: {},
};

export const BannerAlert = ({ children, hide, className = '', handleClose, variant = VariantType.Absolute }: BasicAlertParams) => {

  if (!children || hide) {
    return null;
  }

  return (
    <div className={`${className} background-ThemeAccentExtralight alert--page banner--alert`} style={VARIANT_MAP[variant]}>
      <div className='alert--page__info flex-fill text-ThemeAccentDark d-flex justify-content-center align-items-center'>{children}</div>
      {handleClose ? (
        <div>
          <Button color='link' className='p-0' onClick={handleClose}>
            <i className='fa fa-times' />
          </Button>
        </div>
      ) : null}
    </div>
  );
}
